export const bcpTag = (country, language) => `${language}-${country}`;
//# sourceMappingURL=bcpTag.js.map